import { DatePicker, FormField, Select, todayIso, useToast } from '@ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormDialog } from '../../../app/FormDialog';
import { formErrors } from '../../../lib/errors';
import { useChangeStatus, type Colony, type ColonyStatus } from '../api';

const STATUSES: ColonyStatus[] = ['active', 'dead', 'merged', 'sold', 'given_away'];

export function StatusDialog({
  open,
  onClose,
  colony,
}: {
  open: boolean;
  onClose: () => void;
  colony: Pick<Colony, 'id' | 'name' | 'status'>;
}) {
  const { t } = useTranslation();
  const toast = useToast();
  const change = useChangeStatus();
  const [status, setStatus] = useState<ColonyStatus>(
    colony.status === 'active' ? 'dead' : 'active',
  );
  const [on, setOn] = useState(todayIso());
  const errors = formErrors(change.error, { on: ['colony.status_before_origin'] });
  const close = () => {
    change.reset();
    onClose();
  };
  return (
    <FormDialog
      open={open}
      onClose={close}
      title={t('apiary.statusDialog.title')}
      description={colony.name}
      size="sm"
      submitLabel={t('common.save')}
      pending={change.isPending}
      error={errors.general}
      onSubmit={() =>
        change.mutate(
          { id: colony.id, status, on },
          {
            onSuccess: () => {
              toast.show(t('apiary.statusDialog.saved'));
              close();
            },
          },
        )
      }
    >
      <FormField label={t('apiary.statusDialog.status')}>
        {(p) => (
          <Select
            {...p}
            value={status}
            onChange={(e) => setStatus(e.target.value as ColonyStatus)}
            options={STATUSES.filter((s) => s !== colony.status).map((s) => ({
              value: s,
              label: t(`apiary.status.${s}`),
            }))}
          />
        )}
      </FormField>
      <FormField label={t('apiary.statusDialog.date')} error={errors.field.on}>
        {(p) => <DatePicker {...p} value={on} max={todayIso()} onChange={setOn} />}
      </FormField>
    </FormDialog>
  );
}
